import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle, IconButton, Tooltip } from "@material-ui/core";
import { Cancel } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import { adminUpdateUser } from "../../store/user/action";
import { permissionError } from "../../util/Alert";

const toDateInputValue = (value) => {
  if (!value) return "";
  const iso = String(value).match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (iso) return `${iso[1]}-${iso[2].padStart(2, "0")}-${iso[3].padStart(2, "0")}`;
  const legacy = String(value).match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
  return legacy ? `${legacy[3]}-${legacy[2].padStart(2, "0")}-${legacy[1].padStart(2, "0")}` : "";
};

const EditUserDemographicsDialog = ({ open, onClose, user, field }) => {
  const dispatch = useDispatch();
  const hasPermission = useSelector((state) => state.admin.admin.flag);
  const isBirthday = field === "birthDay";
  const label = isBirthday ? "Birthday" : "Gender";
  const [value, setValue] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open) setValue(isBirthday ? toDateInputValue(user?.birthDay) : user?.gender || "");
  }, [open, isBirthday, user]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (isBirthday && !value) return;
    if (!hasPermission) return permissionError();

    const formData = new FormData();
    formData.append("userId", user._id);
    formData.append("name", user.name || user.username || "");
    formData.append("bio", user.bio || "");
    formData.append(field, value);

    setSubmitting(true);
    const result = await dispatch(adminUpdateUser(formData));
    setSubmitting(false);
    if (result) onClose();
  };

  const today = new Date().toISOString().split("T")[0];
  return (
    <Dialog open={open} onClose={onClose} disableBackdropClick disableEscapeKeyDown fullWidth maxWidth="xs">
      <DialogTitle>
        <span className="text-danger font-weight-bold h4">Edit {label}</span>
      </DialogTitle>
      <IconButton style={{ position: "absolute", right: 0 }}>
        <Tooltip title="Close"><Cancel className="text-danger" onClick={onClose} /></Tooltip>
      </IconButton>
      <DialogContent>
        <form onSubmit={handleSubmit} className="modal-body pt-1 px-1 pb-3">
          <div className="form-group mt-2">
            <label className="mb-2 text-gray">{label}</label>
            {isBirthday ? (
              <input type="date" className="form-control" max={today} value={value} onChange={(event) => setValue(event.target.value)} required />
            ) : (
              <select className="form-select form-control" value={value} onChange={(event) => setValue(event.target.value)}>
                <option value="">Rather not say</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            )}
          </div>
          <div className="mt-5">
            <button type="button" className="btn btn-outline-info ml-2 btn-round float__right icon_margin" onClick={onClose} disabled={submitting}>Close</button>
            <button type="submit" className="btn btn-round float__right btn-danger" disabled={submitting || (isBirthday && !value)}>
              {submitting ? "Saving..." : "Save"}
            </button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default EditUserDemographicsDialog;
